import { Injectable } from '@angular/core';
import { ObservableRequestService } from 'app/services/observable-request.service';
import { ConstantsService } from 'app/services/constants-service';
import { Observable } from 'rxjs/Observable';
import { plainToClass } from 'class-transformer';

import { Group } from 'app/admin/groups/group.model';

/**
* This is a service for group management.
*/
@Injectable()
export class GroupService {
    constructor(private requestService: ObservableRequestService) { }
    // Get all groups for the listing
    getGroups(): Observable<any> {
        return this.requestService.getRequest(ConstantsService.GROUP)
            .map(response => {
                return plainToClass(Group, response.arrResult as Object[]);
            });
    };
    // Get all user elements to fill-up Compliance Officer, External
    // Compliance Officer and Manager drop-downs.
    getUsersList(): Observable<any> {
        return this.requestService.getRequest(ConstantsService.USERS)
            .map(response => {
                return plainToClass(Group, response.arrResult as Object[]);
            });
    }

    // Save groups based on add or edit action.
    addGroup(Group: Object): Observable<any> {
        const saveUri = ConstantsService.GROUP;
        return this.requestService.postRequest(saveUri,
            JSON.stringify(Group),
            this.requestService.getJSONContentType());
    }

    updateGroup(Group: Object): Observable<any> {
        const saveUri = ConstantsService.GROUP;
        return this.requestService.putRequest(saveUri,
            JSON.stringify(Group),
            this.requestService.getJSONContentType());
    }

    deleteGroup(groupDeleteId: Group): Observable<any> {
        return this.requestService.deleteRequest(
            ConstantsService.GROUP,
            this.requestService.serialize(groupDeleteId),
            this.requestService.getFormEncodedContentType());
    }
}



// WEBPACK FOOTER //
// ./src/app/admin/groups/group.service.ts